import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import DemandsApi from "~/admin/apis/demands.api";

import useLayout from "~/hooks/useLayout";
import useDemands from "~/admin/hooks/useDemandsContext";
import useMount from "~/hooks/useMount";

export default function SideMenuItem({
  menuKey,
  icon,
  label,
  path,
  loadNotifs,
  routePrefix,
  onSelect,
}) {
  const {
    layout: { activeMenuKeys },
  } = useLayout();

  const {
    demands: { demands },
  } = useDemands();

  const { setDemands } = useDemands();
  const [active, setActive] = useState(activeMenuKeys.includes(menuKey));
  const ref = useRef();

  useMount(() => {
    if (loadNotifs) {
      loadNbNotifs();
    }
  });

  const loadNbNotifs = async () => {
    let nbNotifs = 0;

    switch (menuKey) {
      case "demands":
        nbNotifs = await DemandsApi.getNb().catch((e) => {
          return null;
        });
        break;
      default:
        nbNotifs = 0;
    }

    if (nbNotifs) {
      setDemands({
        demands: nbNotifs,
      });
    }
  };

  useEffect(() => {
    setActive(activeMenuKeys.includes(menuKey));
  }, [activeMenuKeys, menuKey]);

  useEffect(() => {
    if (active) {
      onSelect(ref.current);
    }
  }, [active, onSelect, activeMenuKeys, menuKey]);

  return (
    <>
      <li
        ref={ref}
        className={`pr-0 flex justify-center transition-all ease-in-out`}
      >
        <React.Fragment>
          <Link
            to={`/${routePrefix}/${path}`}
            className={`flex items-center self-stretch w-full h-[40px] mb-1.5`}
          >
            {icon && (
              <span className="mr-4 text-2xl pl-4 text-white z-50">{icon}</span>
            )}
            <span
              className={`pr-0 transition-all ease-in-out ${
                active
                  ? "text-xl font-[OmnesMedium] text-white font-bold"
                  : "hover:font-bold text-white font-[RobotoLight] text-lg"
              }
          `}
            >
              {label}
            </span>
            {demands > 0 && menuKey === "demands" && (
              <div className="text-white font-bold text-[10px] bg-danger w-4 h-4 text-center rounded-full mb-4">
                {demands}
              </div>
            )}
          </Link>
        </React.Fragment>
      </li>
    </>
  );
}
